import React from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { ButtonGroup, Button } from "Components/ReactstrapSlim";
import { IModulePager } from "Hooks";

export interface ModulePagerControlsProps {
   pager: IModulePager,
   className?: string
}

const ModulePagerControls: React.FC<ModulePagerControlsProps> = ({ children, pager, className, ...rest }) => {
   if (!pager.displayControls)
      return (null);

   return (<ButtonGroup className={classNames("module-pager-controls", className)}>
      <Button color="arctic-20" size="sm" onClick={() => pager.previous()} disabled={!pager.hasPrevious}><Icons.ArrowLeft /></Button>
      <Button color="arctic-20" size="sm" onClick={() => pager.next()} disabled={!pager.hasNext}><Icons.ArrowRight /></Button>
   </ButtonGroup>);
}

export default ModulePagerControls;